/* eslint-disable */
// @ts-nocheck

/* eslint-enable prettier/prettier */
/* eslint-enable @typescript-eslint/no-unused-vars */
/* eslint-enable import/no-unresolved */

import React from "react";

import WordsCloud from "./WordsCloud";
import TextOptionsBody from "./TextOptionsBody";

type TProps = {
  option: {
    id: number;
    type: string;
    limit_reached?: boolean;
    total_answers?: number;
  };
  showAccessibleView?: boolean;
  textSize?: number;
};

function TextOptionsCard({
  option,
  showAccessibleView = false,
  textSize = 1.0,
}: TProps) {
  const isTextFieldType = option.type === "Survey::Option::Textfield";

  if (!isTextFieldType) {
    return (
      <TextOptionsBody
        answers={option.answer_counts}
        limitReached={option.limit_reached}
        totalAnswers={option.total_answers}
        textSize={textSize}
      />
    );
  }
  return (
    <WordsCloud
      answers={option.answer_counts}
      showAccessibleView={showAccessibleView}
      textSize={textSize}
    />
  );
}

export default TextOptionsCard;
